import { render, staticRenderFns } from "./faqList.vue?vue&type=template&id=2278a5ba&scoped=true&"
import script from "./faqList.vue?vue&type=script&lang=js&"
export * from "./faqList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278a5ba",
  null
  
)

export default component.exports